import { createSlice } from '@reduxjs/toolkit';

// Slice d'exemple pour l'UI globale (thème, chargements, etc.)
const initialState = {
  theme: 'light',
  loadingCount: 0,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setTheme(state, action) {
      state.theme = action.payload;
    },
    startLoading(state) {
      state.loadingCount += 1;
    },
    stopLoading(state) {
      state.loadingCount = Math.max(0, state.loadingCount - 1);
    },
  },
});

export const { setTheme, startLoading, stopLoading } = appSlice.actions;
export default appSlice.reducer;
